import { graphql } from "@/lib/gql/__generated__";

export const SendCustomMailSettingMutationForReservationUpdate = graphql(/* GraphQL */ `
	mutation testCustomMailSendAtReservationUpdate($input: CustomMailSettingTestMailInput!) {
		testCustomMailSendAtReservationUpdate(input: $input) {
			userErrors
			success
		}
	}
`);
